import { Leaf } from "lucide-react";

export const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-[#E2F0E6] px-5 py-10 sm:px-8">
    <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-3 text-center text-sm text-[#666666] sm:flex-row sm:text-left">
      <p data-testid="footer-copyright">© 2026 AgriYuvaa. All Rights Reserved.</p>
      <p data-testid="footer-tagline" className="flex items-center gap-2">
        Empowering the Next Generation of Agriculture.
        <Leaf className="h-4 w-4 text-[#16803C]" aria-hidden="true" />
      </p>
    </div>
  </footer>
);
